// extracted by mini-css-extract-plugin
export var marker = "Marker__marker-8xmYE";
export var toolTips = "Marker__toolTips-dUtrN";